module.exports = __webpack_public_path__ + "static/media/claw-marks.48c3065b.svg";